class ConditionTree {
  constructor (initialData = []) {
    this.data = [...initialData] // flat array
    this.root = [] // formatted tree
    this._rebuild() // build immediately
  }

  // ---------- Private Rebuild ----------
  _rebuild () {
    const map = {}
    const roots = []

    this.data.forEach(item => {
      map[item.id] = { ...item, children: [] }
    })

    this.data.forEach(item => {
      if (item.parentId === null) {
        roots.push(map[item.id])
      } else if (map[item.parentId]) {
        map[item.parentId].children.push(map[item.id])
      }
    })

    this.root = roots // always keep updated
  }

  // ---------- Generate Unique ID ----------
  generateId () {
    return Date.now().toString() + Math.random().toString(16).slice(2)
  }

  // ---------- Get Flat ----------
  getFlat () {
    return [...this.data]
  }

  // ---------- Get Tree ----------
  getTree () {
    return this.root
  }

  // ---------- Add Node ----------
  addNode (parentId = null, nodeData = {}) {
    const newNode = {
      id: this.generateId(),
      parentId,
      field: 'Forecast category',
      operator: 'is any of',
      values: [],
      ...nodeData
    }

    this.data.push(newNode)
    this._rebuild() // auto update tree
    return newNode
  }

  // ---------- Update Node ----------
  updateNode (nodeId, updatedFields) {
    this.data = this.data.map(item =>
      item.id === nodeId ? { ...item, ...updatedFields } : item
    )

    this._rebuild() // auto update tree
  }

  // ---------- Delete Node ----------
  deleteNode (nodeId) {
    const idsToDelete = new Set()

    const collect = (id) => {
      idsToDelete.add(id)
      this.data
        .filter(item => item.parentId === id)
        .forEach(child => collect(child.id))
    }

    collect(nodeId)

    this.data = this.data.filter(item => !idsToDelete.has(item.id))
    this._rebuild() // auto update tree
  }

  // ---------- Move Node ----------
  moveNode (nodeId, newParentId) {
    this.updateNode(nodeId, { parentId: newParentId })
  }

  // ---------- Get Node ----------
  getNode (nodeId) {
    return this.data.find(item => item.id === nodeId)
  }

  // ---------- Reset ----------
  setData (newData) {
    this.data = [...newData]
    this._rebuild()
  }
}

export default ConditionTree
